import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
    el: ".banner .swiper-pagination",
    clickable: true,
  },
}); 

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section2").offset().top - $(".section2 .content").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > $(".section2").offset().top - $(".section2 .content").height() - $("header").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})


var section3 = new Swiper(".section3 .swiper", {
    spaceBetween: '2.75%',
    slidesPerView: 5,
    slidesPerGroup: 5,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
	loop:true,//必须
    pagination: {
        el: ".section3 .swiper-pagination",
        clickable: true,
      },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: '2.75%',
            slidesPerView: 5,
            slidesPerGroup: 5,
        },
        768: {  //当屏幕宽度小于等于1280
            spaceBetween: '2.75%',
            slidesPerView: 3,
            slidesPerGroup: 3,
        },
        320: {  //当屏幕宽度小于等于320
            spaceBetween: 10,
            slidesPerView: 2,
            slidesPerGroup: 2,
        }
    }, 
});


var solution1 = new Swiper(".section4 .mySwiper", {
    direction: "vertical",
    spaceBetween: 35,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: 35,
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            spaceBetween: 0,
        }
    },
});
var solution2 = new Swiper(".section4 .mySwiper2", {
    direction: "vertical",
    thumbs: {
        swiper: solution1,
    },
    navigation: {
        nextEl: ".section4 .swiper-button-next",
        prevEl: ".section4 .swiper-button-prev",
    },
});


var global = new Swiper(".section7 .swiper", {
    spaceBetween: 35,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: ".section7 .swiper-button-next",
        prevEl: ".section7 .swiper-button-prev",
    },
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: 28,
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 20,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
            spaceBetween: 0,
        }
    },
});